<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Toolbar from '../email/toolbar'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { VueEditor } from 'vue2-editor'

export default {
  page: {
    title: 'Tambah Kantor',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: { VuePerfectScrollbar, Layout, PageHeader, Toolbar, Multiselect, VueEditor },
  data() {
    return {
      title: 'Tambah Kantor',
      isVisible: true,
      data : [],
      offices: [],
    }
  },
  methods: {
    sendData(){
      var payload = {
        officeName : this.data.officeName,
        address : this.data.address
      };

      axios({
        method: 'post',
        data: payload,
        url: 'office'
      }).then(response => {
        if (response.status === 200) {
          this.$router.push('/apps/mastery/office'); 
          this.$swal({
            icon: 'success',
            html: 'Data tersimpan!',
            showCloseButton: false,
            focusConfirm: true,
            confirmButtonText: 'Oke',
          }).then((result) => {
          });
        } 
      }, error => {
        this.$bvToast.toast('Error', {
          title: 'Information',
          variant: 'danger'
        })
      });
    },
    remove() {
      this.isVisible = false
    },
  },
  created() {
    this.loadOffices();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="bg-transparent">
          <div class="btn-group mb-2">
            <router-link to="/apps/mastery/office" class="btn btn-light"><i class="uil uil-arrow-left"></i> Kembali</router-link>
            <button class="btn btn-primary" @click.prevent="sendData"><i class="uil uil-check"></i> Simpan</button>
          </div>
        </div>
      </div>

      <div class="col-12 mt-3">
        <div class="card">
          <div class="card-body">
            <b-form class="form-horizontal">
              <div class="row">
                <div class="col">

                  <b-form-group
                    label-cols-sm="10"
                    label-cols-lg="2"
                    label="Nama"
                    label-for="input-name"
                  >
                    <b-form-input
                      id="input-name"
                      v-model="data.officeName"
                      placeholder="Nama"
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    label-cols-sm="10"
                    label-cols-lg="2"
                    label="Alamat"
                    label-for="input-address"
                  >
                    <b-form-input
                      id="input-address"
                      v-model="data.address"
                      placeholder="Alamat"
                    ></b-form-input>
                  </b-form-group>

                </div>
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card-->
      </div>
      <!-- end col -->
      
    </div>
  </Layout>
</template>

<style type="text/css">
</style>